import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseGovermentAllocationDistributionsLimitsProps<T> = {
  governmentAllocationId?: string;
  filters?: {
    search?: string;
    page?: number;
  }
  mapper?: (data: any) => T
}

export const useGovernmentAllocationsDistributionsLimits = <T,>({
  governmentAllocationId,
  filters: { search = '', page = 1 } = {},
  mapper = Mapper.default<T>(),
}: UseGovermentAllocationDistributionsLimitsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['governmentAllocationsDistributionsLimits', governmentAllocationId, search, page],
    queryFn: () => {
      return privateAxios.get(`/billing/government_allocations/${governmentAllocationId}/distributions_limits`, {
        params: {
          search,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest }
}
